export enum MeasurementUnit {
  distanceLarge = "distanceLarge",
  distanceLargeAndSmall = "distanceLargeAndSmall",
  distanceSmall = "distanceSmall",
  distanceTiny = "distanceTiny",
}